import { Loader2 } from "lucide-react";
import { useState } from "react";

import type { InsightsView, PublishTab } from "./publishSearch";

import { ConnectMetaPage } from "./components/ConnectMetaPage";
import { LinkPagesModal } from "./components/LinkPagesModal";
import { PublishPage } from "./components/PublishPage";
import { useConnectMeta } from "./hooks/useConnectMeta";
import { useSocialConnection } from "./hooks/useSocialConnection";

export function SocialPublishing({
  postId,
  tab,
  view,
}: {
  postId?: number;
  tab?: PublishTab;
  view?: InsightsView;
}) {
  const { data: connection, isLoading } = useSocialConnection();
  const [isLinkPagesOpen, setIsLinkPagesOpen] = useState(false);
  const { connect, isConnecting } = useConnectMeta({
    enabled:
      connection !== undefined &&
      (!connection.connected || connection.hasErrors),
    onConnected: () => setIsLinkPagesOpen(true),
  });

  if (isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loader2 className="size-8 animate-spin text-text-brand-secondary" />
      </div>
    );
  }

  return (
    <>
      {connection?.isProjectConnected ? (
        <PublishPage
          connection={connection}
          isConnecting={isConnecting}
          onConnect={connect}
          onLinkPages={() => setIsLinkPagesOpen(true)}
          postId={postId}
          tab={tab}
          view={view}
        />
      ) : (
        <ConnectMetaPage isConnecting={isConnecting} onConnect={connect} />
      )}
      <LinkPagesModal
        isOpen={isLinkPagesOpen}
        onClose={() => setIsLinkPagesOpen(false)}
      />
    </>
  );
}
